import { AbstractBprocRequest } from "../../../../cuba/entities/base/AbstractBprocRequest";

// 🔹 Статусы запроса
export enum AbstractRequestStatusEnum {
  DRAFT = "DRAFT",
  TO_BE_REVISED = "TO_BE_REVISED",
  APPROVING = "APPROVING",
  ON_HOLD = "ON_HOLD",
  APPROVED = "APPROVED",
  REJECT = "REJECT",
  CANCELED_BY_INITIATOR = "CANCELED_BY_INITIATOR",
}

export const getStatuses = <T extends AbstractBprocRequest>(
  dataInstance: T | null,
) => {
  if (!dataInstance || !dataInstance.status?.code) {
    return {
      getStatusCode: () => "",
      isNotDraft: () => false,
      isNotDraftVRE: () => false,
      isOnApproving: () => false,
      isOnHold: () => false,
      isOnRevision: () => false,
      isEnd: () => false,
      status: "",
    };
  }

  const status = dataInstance.status.code;

  const getStatusCode = () => status;

  const isNotDraft = () =>
    status !== AbstractRequestStatusEnum.DRAFT &&
    status !== AbstractRequestStatusEnum.TO_BE_REVISED;

  const isNotDraftVRE = () => status !== "DRAFT" && status !== "TO_BE_REVISED";

  const isOnApproving = () => status === AbstractRequestStatusEnum.APPROVING;

  const isOnHold = () => status === AbstractRequestStatusEnum.ON_HOLD;

  const isOnRevision = () => status === AbstractRequestStatusEnum.TO_BE_REVISED;

  const isEnd = () =>
    status === AbstractRequestStatusEnum.APPROVED ||
    status === AbstractRequestStatusEnum.CANCELED_BY_INITIATOR ||
    status === AbstractRequestStatusEnum.REJECT;

  return {
    getStatusCode,
    isNotDraft,
    isNotDraftVRE,
    isOnApproving,
    isOnHold,
    isOnRevision,
    isEnd,
    status,
  };
};
